import { FormControl } from 'react-bootstrap';
import FormGroup, { FormGroupProps } from 'components/FormGroup';

interface RealNameProps extends FormGroupProps {
    disabled?: boolean;
    /** 额外的校验，比如限制只能输入中文 */
    customChecker?: (value: string) => boolean | string;
}

const RealName: React.FC<RealNameProps> = ({ disabled, customCheck, ...restProps }) => {
    return (
        <FormGroup
            label={__('Label:姓名')}
            name="real_name"
            disabled={disabled}
            checker={value => {
                if (disabled) {
                    return true;
                }

                if (!value) {
                    return __('请输入姓名');
                }

                if (value.length < 2 || value.length > 110) {
                    return __('名字必须在2到110个字之间');
                }

                return customCheck ? customCheck(value) : true;
            }}
            {...restProps}>
            <FormControl placeholder={__('Label:姓名')} disabled={disabled} />
        </FormGroup>
    );
};

export default RealName;
